// Utils
import { createNamespace, isDef } from '../utils';
import { inherit } from '../utils/functional';
const [createComponent, bem] = createNamespace('info');
const isNumber = (i) => typeof i === 'number';
const maxContent = (max, info) => {
    if (info <= max) {
        return info;
    }
    return max + '+';
};
function Info(h, props, slots, ctx) {
    const { dot, info } = props;
    const showInfo = isDef(info) && info !== '';
    if (!dot && !showInfo) {
        return;
    }
    return (<div class={bem({ dot })} {...inherit(ctx, true)}>
      {dot ? '' : ((isNumber(props.info) && props.badgemax) ? maxContent(props.badgemax, props.info) : props.info)}
    </div>);
}
Info.props = {
    dot: Boolean,
    info: [Number, String],
    badgemax: Number,
};
export default createComponent(Info);
